module.exports = require("dompurify");


//////////////////
// WEBPACK FOOTER
// external "dompurify"
// module id = 617
// module chunks = 0